export interface IGetInvoicesResponse {
  invoices: Invoice[];
}

export interface Tariff {
  id: number;
  identifier: string;
  dueDate: string;
  invoiceId: number;
}

export interface Invoice {
  id: number;
  createdAt: string;
  value: string;
  status: string;
  channelId: number;
  typeOfPayment: string;
  clientDocument: string;
  category: string;
  dueDate: string;
  startDate: string;
  endDate: string;
  contractIds: number[];
  products: string[];
  isPayableByPix: boolean;
  isPaymentRequired: boolean;
  statusRelevantDate?: string;
}

export enum InvoiceStatusEnum {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  CANCELED = "CANCELED"
}

export enum InvoiceStatusLabel {
  OPEN = "Em aberto",
  CLOSED = "Fechada",
  CANCELED = "Cancelada"
}

export interface PaginationInfo {
  page: number;
  hasMore: boolean;
  totalPages?: number;
  totalCount?: number;
}
